import { useQuery } from "react-query";
import API from "../../services/API";
import { Alert } from "@mui/material";
import { Link } from "react-router-dom";

export default function PiSignatureAlert() {
    const { data: regs, isSuccess } = useQuery({ 
        queryKey: ['piMissingSignatures'], 
        queryFn: async () => {
            const response = await API.get('/dpc/missing-signatures')
            return response.data;
        }
    });

    if (!isSuccess || !regs || regs?.length === 0) return <></>;

    const reg = regs[0];

    return (
        <Alert severity="error" component={Link} to={`/dpc/participation/${reg?.id}/signature`}>
            Vous devez impérativement <u>signer votre attestation de participation</u> à la formation <b>{reg?.session?.action?.name}</b>.
        </Alert>
    );
}